import React, { useEffect, useState, useContext } from "react";
import { themeContext } from "../../App";
import RightSideHeader from "./rightSideHeader";
import { styles } from "./styles";
import logo from "../../img/headerLogo.png";
import nkcvts from "../../img/nkc.png";
import config from "../../config/config";
import logoDlb from "../../img/djb.png";
import ioclfleet from "../../img/LOGOIOCL.png";
import watsoofleet from "../../img/watsoo.png";
import CreateTickets from "./CreateTickets";

const Header = ({ events = [], setEvents = () => { } }) => {
   const [isOpen, setOpen] = useState(false);
  const { color } = useContext(themeContext);
  console.log(color);
  // Function to darken a hex color by a specified percentage
  const darkenColor = (hexColor, percent) => {
    debugger;
    // Parse hex color to RGB
    // Remove the hash if it's present
    const hex = hexColor.replace(/^#/, "");

    // Parse the hex values for each color component
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    // Return the RGB values as an object
    // return { r, g, b };

    // Darken the color (adjust the percentage as needed)
    const darkenAmount = 1 - percent / 100;
    const darkenedColor = `#${Math.round(r * darkenAmount).toString(
      16,
    )}${Math.round(g * darkenAmount).toString(16)}${Math.round(
      b * darkenAmount,
    ).toString(16)}`;
    console.log(darkenedColor);
    return darkenedColor;
  };
  const [img, setIMG] = useState();
  console.log(img, "logoimg");
  const [fileView, setFileView] = useState();
  console.log(fileView, "fileView");
  const raiseAnIssueHandler = () => {
    setOpen(true);
    console.log("first")
  };
  return (
    <header
      className="header"
      style={{
        // background: 'linear-gradient("90deg", "#fff", "10%", color, "100%")',
        backgroundImage: `#ffff`,
      }}
    >
      <div style={styles.headerSubContainer}>
        <div style={styles.logoContainer}>
          {config.NkcWeb &&
            !JSON.parse(localStorage.getItem("data"))?.allowMusic ? (
            <div style={{
              width: 180,
              height: 52,
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
            }}>
              <img
                src={
                  JSON.parse(localStorage.getItem("config"))?.logoUrl
                    ? JSON.parse(localStorage.getItem("config"))?.logoUrl
                    : watsoofleet
                }
                // src={
                //   JSON.parse(localStorage.getItem("dealerLogoUrl"))
                //     ? JSON.parse(localStorage.getItem("dealerLogoUrl"))
                //     : JSON.parse(localStorage.getItem("data"))?.userLogoUrl
                //       ? JSON.parse(localStorage.getItem("data"))?.userLogoUrl
                //       : JSON.parse(localStorage.getItem("data"))?.parentLogoUrl
                //         ? JSON.parse(localStorage.getItem("data"))?.parentLogoUrl
                //         : JSON.parse(localStorage.getItem("config"))?.logoUrl
                //           ? JSON.parse(localStorage.getItem("config"))?.logoUrl
                //           : watsoofleet
                // }
                alt="header_icon"
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  width: "auto",
                  height: "auto",
                  objectFit: "contain",
                  display: "block",
                }}
              />
            </div>
          ) : null}

          {/* {
            config.NkcWeb && 
            <img src={window.location.hostname.split(".")[0]=='ioclfleet'?ioclfleet:window.location.hostname.split(".")[0]=='nkcfms'?JSON.parse(localStorage.getItem("config")).logo:watsoofleet} alt='header_icon' />

          } */}
          {config.VTSWeb && <img src={logo} alt="header_icon" />}
          {config.BJBWeb && <img src={logoDlb} alt="header_icon" />}
        </div>
        <RightSideHeader
          img={img}
          setIMG={setIMG}
          setFileView={setFileView}
          fileView={fileView}
          events={events}
          setEvents={setEvents}
           raiseAnIssueHandler={raiseAnIssueHandler}
        />

        <CreateTickets open={isOpen} onClose={() => setOpen(false)} />
      </div>
    </header>
  );
};

export default Header;
